import logger from 'utils/logger';

export interface DecodedUser {
  id: string;
  role: string;
  exp: number;
  iat: number;
}

export function decodeAccessToken(token: string): DecodedUser | null {
  try {
    // JWT structure: header.payload.signature
    const parts = token.split('.');
    if (parts.length !== 3) {
      logger.error('Invalid JWT format');
      return null;
    }

    // Decode the payload (second part)
    const payload = parts[1];
    const decodedPayload = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    const parsedPayload = JSON.parse(decodedPayload);

    // Check if token is expired
    const currentTime = Math.floor(Date.now() / 1000);
    if (parsedPayload.exp && parsedPayload.exp < currentTime) {
      logger.warn('Token has expired');
      return null;
    }

    return {
      id: parsedPayload.sub,
      role: parsedPayload.role,
      exp: parsedPayload.exp,
      iat: parsedPayload.iat,
    };
  } catch (error) {
    logger.error('Failed to decode JWT:', error);
    return null;
  }
}

export function isTokenExpired(token: string): boolean {
  const decoded = decodeAccessToken(token);
  if (!decoded) return true;

  const currentTime = Math.floor(Date.now() / 1000);
  return decoded.exp < currentTime;
}
